export default __webpack_public_path__ + "static/media/visibility_off.96cb0b4f.svg";